import Vue from 'vue'
import Router from 'vue-router'
import Facade from '@/pages/Index'
import About from '@/pages/About'
import Franchise from '@/pages/Franchise'
import Discount from '@/pages/Discount'
import Contact from '@/pages/Contact'
import Joinus from '@/pages/Joinus'
import Result from '@/pages/Result'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Facade
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/franchise',
      name: 'franchise',
      component: Franchise
    },
    {
      path: '/discount',
      name: 'discount',
      component: Discount
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/joinus',
      name: 'joinus',
      component: Joinus
    },
    {
      path: '/result',
      name: 'result',
      component: Result
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js